import { Checkbox } from "@nextui-org/react";
const timebasedcolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "date",
    label: "Date",
  },
  {
    key: "examName",
    label: "Exam",
  },
  {
    key: "totalMcq",
    label: "Total Qs",
  },
  {
    key: "totalTime",
    label: "Total Time",
  },
  {
    key: "timeRemaining",
    label: "Remaining Time",
  },
  {
    key: "actions",
    label: "Action",
  },
];

export { timebasedcolumn };
